module.exports = __webpack_public_path__ + "img/icon-Cal-Yahoo.562e45d5.png";